<header class="">
  <div class="row">
    <nav class="top-bar" data-topbar="">
      <ul class="title-area">
        <li class="name">
          <h1>
            <a target="_blank" href="/home">
              <img class="logo" src="../../assets/images/logo (1).png"/>
              <img class="mini-logo" src="../../assets/images/mini-logo.png">
            </a>
          </h1>
        </li>
        <li class="toggle-topbar menu-icon">
          <a (click)="toggleMenu()"><span></span></a>
        </li>
        <!-- <li class="mobile-lang"><a  target="_blank" href="http://aban.net/en">En</a></li> -->
      </ul>

      <section class="top-bar-section">
        <!-- Left Nav Section -->
        <ul class="left">
          <li class="tools">
            <div class="search">
              <span style="width: 50px"></span>
              <!-- <i class="fa fa-search"></i>
                            <form action="https://aban.capital" method="get">
                                <input name="s" type="text" placeholder="جستـجو">
                                <input type="submit" value="">
                            </form> -->
            </div>
            <div class="language"></div>
          </li>
          <!-- MENU -->

          <li #menuItem1 class="has-dropdown hide-for-medium-up lvl1 not-click">
            <!-- RESPONSIVE -->
            <a>سبدگردان آبان</a>
            <ul class="dropdown">
              <li class="title back js-generated">
                <h5><a href="javascript:void(0)"></a></h5>
              </li>
              <li class="parent-link hide-for-medium-up">
                <a class="parent-link js-generated" target="_blank" href="#">سبدگردان آبان</a>
              </li>
              <!-- IF HAS CHILD -->
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">آشنایی با ما</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a class="parent-link js-generated" target="_blank" href="#">آشنایی با ما</a>
                  </li>

                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="portfolio-management/about-us">معرفی شرکت</a>
                  </li>
                  <li class="lvl3">
                    <a target="_blank" routerLink="portfolio-management/our-services">درباره ما</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="portfolio-management/team-members">اعضای تیم</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>

              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">همکاری با ما</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a class="parent-link js-generated" target="_blank" href="#">همکاری با ما</a>
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="portfolio-management/job-opportunities">فرصت‌های شغلی</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="portfolio-management/cooperation-request">پیشنهاد همکاری</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>
            </ul>
          </li>
          <li class="show-for-medium-up">
            <!-- DESKTOP-->
            <a target="_blank" href="#" data-dropdown="mega-menu-1" data-options="is_hover:true" class=""
              aria-expanded="false">سبدگردان آبان</a><!-- megamenu IDs should change.  -->
            <div id="mega-menu-1" data-dropdown-content="" class="large f-dropdown content row"
              style="position: absolute; left: -99999px; top: 48px" aria-hidden="true">
              <!-- ID should change -->
              <div class="medium-6 columns">
                <h6><a target="_blank" href="#">آشنایی با ما</a></h6>
                <ul>
                  <li>
                    <a target="_blank" routerLink="portfolio-management/our-services">معرفی شرکت</a>
                  </li>
                  <li>
                    <a target="_blank" routerLink="portfolio-management/about-us">درباره ما</a>
                  </li>
                  <li>
                    <a target="_blank" routerLink="portfolio-management/team-members">اعضای تیم</a>
                  </li>
                </ul>
              </div>

              <div class="medium-6 columns">
                <h6><a target="_blank" href="#">همکاری با ما</a></h6>
                <ul>
                  <li>
                    <a target="_blank" routerLink="portfolio-management/job-opportunities">فرصت‌های شغلی</a>
                  </li>
                  <li>
                    <a target="_blank" routerLink="portfolio-management/cooperation-request">پیشنهاد همکاری</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li #menuItem1 class="has-dropdown hide-for-medium-up lvl1 not-click">
            <!-- RESPONSIVE -->
            <a>خدمات</a>
            <ul class="dropdown">
              <li class="title back js-generated">
                <h5><a href="javascript:void(0)"></a></h5>
              </li>
              <li class="parent-link hide-for-medium-up">
                <a class="parent-link js-generated" target="_blank" href="#">خدمات</a>
              </li>
              <!-- IF HAS CHILD -->
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">سبدگردانی</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a class="parent-link js-generated" target="_blank"
                      routerLink="services/modiriyat-sarmayeh-gozari">سبدگردانی</a>
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="services/dedicated-investment-management">مدیریت اختصاصی سرمایه
                      گذاری</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="services/management-investment-funds">مدیریت صندوق های سرمایه
                      گذاری</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">صندوق‌ها</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a class="parent-link js-generated" target="_blank" href="#">صندوق‌ها</a>
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" href="https://aban.aban.net/User/Login">صندوق یکم آبان</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" href="https://pars.aban.net/User/Login">صندوق پارس</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" href="https://omid.aban.net/User/Login">صندوق ندای امید</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" href="https://kosar1fund.ir/User/Login">صندوق کوثر یکم</a>
                  </li>

                </ul>
              </li>
            </ul>
          </li>
          <li class="show-for-medium-up">
            <!-- DESKTOP-->
            <a target="_blank" href="#" data-dropdown="mega-menu-1" data-options="is_hover:true" class=""
              aria-expanded="false">خدمات</a><!-- megamenu IDs should change.  -->
            <div id="mega-menu-1" data-dropdown-content="" class="large f-dropdown content row"
              style="position: absolute; left: -99999px; top: 48px" aria-hidden="true">
              <!-- ID should change -->
              <div class="medium-6 columns">
                <!-- <h6><a target="_blank" href="#">خدمات</a></h6> -->
                <ul>
                  <li>
                    <a target="_blank" routerLink="services/dedicated-investment-management">مدیریت اختصاصی سرمایه
                      گذاری</a>
                  </li>
                  <li>
                    <a target="_blank" routerLink="services/management-investment-funds">مدیریت صندوق های سرمایه
                      گذاری</a>
                  </li>

                </ul>
              </div>

            </div>
          </li>
          <li #menuItem1 class="has-dropdown hide-for-medium-up lvl1 not-click">
            <!-- RESPONSIVE -->
            <a>مشتریان</a>
            <ul class="dropdown">
              <li class="title back js-generated">
                <h5><a href="javascript:void(0)"></a></h5>
              </li>
              <li class="parent-link hide-for-medium-up">
                <a class="parent-link js-generated"  href="#">مشتریان</a>
              </li>
              <!-- IF HAS CHILD -->
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">سبدگردانی</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a class="parent-link js-generated" target="_blank" href="#">سبدگردانی</a>
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" href="https://portfolio.aban.net/">مشتریان سبدگردانی</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="/services/portfolio-profit">بازدهی سبدهای اختصاصی</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">صندوق‌ها</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a class="parent-link js-generated" target="_blank" href="#">صندوق‌ها</a>
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" href="https://aban.aban.net/User/Login">صندوق یکم آبان</a>
                  </li>
                   <!-- RED -->
                   <li class="lvl3">
                    <a target="_blank" href="https://omid.aban.net/User/Login"> صندوق ندای امید</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" href="https://pars.aban.net/User/Login"> صندوق پارس</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" href="https://kosar1fund.ir/User/Login">صندوق کوثر یکم</a>
                  </li>

                </ul>
              </li>
            </ul>
          </li>
          <li class="show-for-medium-up">
            <!-- DESKTOP-->
            <a target="_blank" href="#" data-dropdown="mega-menu-3" data-options="is_hover:true" class=""
              aria-expanded="false">مشتریان</a><!-- megamenu IDs should change.  -->
            <div id="mega-menu-3" data-dropdown-content="" class="large f-dropdown content row"
              style="position: absolute; left: -99999px; top: 93px" aria-hidden="true">
              <div class="medium-4 columns">
                <!-- <h6><a target="_blank" href="#">مشتریان</a></h6> -->
                <ul>
                  <li>
                    <a style="display: flex; align-items: center; justify-content: start; font-size: 12pt; margin-bottom: 0; padding: 1rem;cursor:default"
                       >ورود به حساب کاربری</a>
                  </li>
                </ul>
              </div>
              <div class="medium-4 columns">
                <!-- <h6><a target="_blank" href="#">مشتریان</a></h6> -->
                <ul  style="margin-top: 3rem;">
                  <li>
                    <a target="_blank" href="https://portfolio.aban.net/auth/Login">مشتریان سبد‌های
                      اختصاصی</a>
                  </li>
                </ul>
              </div>

              <div class="medium-4 columns">
                <ul style="margin-top: 3rem;">
                  <li>
                    <a target="_blank" href="https://abfund.ir/User/Login">صندوق یکم آبان</a>
                  </li>
                  <li>
                    <a target="_blank" href="https://omid.aban.net/User/Login">صندوق ندای امید</a>
                  </li>
                  <li>
                    <a target="_blank" href="https://parsfund.ir/User/Login">صندوق پارس</a>
                  </li>
                  <!-- RED -->
                  <li class="">
                    <a target="_blank" href="https://kosar1fund.ir/User/Login">صندوق کوثر یکم</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li class="lvl1">
            <a target="_blank" routerLink="/services/portfolio-profit"
              [queryParams]="{ type: 'صندوق-های-سرمایه-گذاری' }">بازدهی
              سبد‌های
              اختصاصی</a>
          </li>
          <li #menuItem1 class="has-dropdown hide-for-medium-up lvl1 not-click">
            <!-- RESPONSIVE -->
            <a target="_blank" routerLink="portfolio-management/offices">تماس با ما</a>
            <ul class="dropdown">
              <li class="title back js-generated">
                <h5><a href="javascript:void(0)"></a></h5>
              </li>
              <li class="parent-link hide-for-medium-up">
                <a target="_blank" href="#">تماس با ما</a>
              </li>
              <!-- IF HAS CHILD -->
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a class="parent-link js-generated" target="_blank" routerLink="portfolio-management/offices">دفتر
                      مرکزی</a>
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="portfolio-management/contact-request">درخواست تماس تلفنی</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" routerLink="portfolio-management/complaints-form">شکایات</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>
            </ul>
          </li>
          <li class="show-for-medium-up">
            <!-- DESKTOP-->
            <a target="_blank" href="#">تماس با ما</a>

            <div id="mega-menu-1" data-dropdown-content="" class="large f-dropdown content row"
              style="position: absolute; left: -99999px; top: 48px" aria-hidden="true">
              <!-- ID should change -->
              <div class="medium-6 columns left">
                <ul>
                  <li>
                    <a target="_blank" routerLink="portfolio-management/offices">دفتر مرکزی</a>
                  </li>
                  <li>
                    <a target="_blank" routerLink="portfolio-management/contact-request">درخواست تماس تلفنی</a>
                  </li>
                  <li>
                    <a target="_blank" routerLink="portfolio-management/complaints-form">شکایات</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </nav>
    <!-- End Header and Nav -->
  </div>
</header>